// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-container-Yluz6 {
  display: flex;
  align-items: center;
}

.brand-title_container-zGJnp {
  margin-left: 24px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/brand/brand.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n}\n\n.title_container {\n  margin-left: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `brand-container-Yluz6`,
	"title_container": `brand-title_container-zGJnp`
};
export default ___CSS_LOADER_EXPORT___;
